import { CustomerModel } from "types/documentationApi.types";

export const sortCustomersByName = (list: CustomerModel[]): CustomerModel[] =>
  [...list].sort((a, b) =>
    (a.customerName as string).toLowerCase() >= (b.customerName as string).toLowerCase() ? 1 : -1
  );
